<template>

    <div class="containerBox">
        <div class="zxkc_tile">在线课程</div>
        <div class="zxkc_content">
            <div class="zxkc_content_left">
                <div class="zxkc_content_left_item_unactive"
                    :class="type == '教学视频' ? 'zxkc_content_left_item_active' : ''" @click="changeType('教学视频')">教学视频
                </div>
                <div class="zxkc_content_left_item_unactive"
                    :class="type == '教学PPT' ? 'zxkc_content_left_item_active' : ''" @click="changeType('教学PPT')">教学PPT
                </div>
                <div class="zxkc_content_left_item_unactive"
                    :class="type == '实验讲义' ? 'zxkc_content_left_item_active' : ''" @click="changeType('实验讲义')">实验讲义
                </div>
                <div class="zxkc_content_left_item_unactive"
                    :class="type == '演示视频' ? 'zxkc_content_left_item_active' : ''" @click="changeType('演示视频')">演示视频
                </div>

            </div>
            <div class="zxkc_content_center"></div>
            <div class="zxkc_content_right_type1" v-if="type == '教学视频'">
                <div class="zxkc_content_right_mp4" v-if="listShow.length > 0">
                    <div class="zxkc_content_right_mp4_item" v-for="(item, index) in  listShow" @click="toDetail(item)">
                        <div class="zxkc_content_right_mp4_item_img"><img
                                :src="getUrl + item.imgUrl" /></div>
                        <div class="zxkc_content_right_mp4_item_text" style="display: -webkit-box;
-webkit-line-clamp: 1;
-webkit-box-orient: vertical;
overflow: hidden;
text-overflow: ellipsis;">{{ item.title }}</div>
                    </div>
                    <div class="el_pagination">
                        <el-pagination background layout="prev, pager, next" :page-size="9" :total="total"
                            @current-change="pageChange">
                        </el-pagination>
                    </div>
                </div>
                <div v-else
                    style="height: 100%; width: 100%;  display: flex; justify-content: center; color: #333333;">
                    <img style="height: 50%; width: 40%; object-fit: cover;"  src="../images/bgk.jpg"/>
                     
                </div>

            </div>
            <div class="zxkc_content_right_type2" v-if="type == '教学PPT'">
                <div class="zxkc_content_right_ppt" v-if="listShow.length > 0">
                    <div class="zxkc_content_right_ppt_item" v-for="(item, index) in  listShow">
                        <div class="zxkc_content_right_ppt_item_text">
                            <div class="zxkc_content_right_ppt_item_text_left" style="display: -webkit-box;
-webkit-line-clamp: 1;
-webkit-box-orient: vertical;
overflow: hidden;
text-overflow: ellipsis;">
                                {{ item.title }}</div>
                            <div class="zxkc_content_right_ppt_item_text_right" @click="toDetail(item)">在线预览>></div>
                        </div>
                        <div class="zxkc_content_right_ppt_item_line">
                        </div>
                    </div>
                    <div class="el_pagination">
                        <el-pagination background layout="prev, pager, next" :page-size="9" :total="total"
                            @current-change="pageChange">
                        </el-pagination>
                    </div>
                </div>
                <div v-else
                    style="height: 100%; width: 100%;  display: flex; justify-content: center; color: #333333;">
                    <img style="height: 50%; width: 40%; object-fit: cover;"  src="../images/bgk.jpg"/>
                     
                </div>

            </div>
            <div class="zxkc_content_right_type2" v-if="type == '实验讲义'">
                <div class="zxkc_content_right_ppt" v-if="listShow.length > 0">
                    <div class="zxkc_content_right_ppt_item" v-for="(item, index) in  listShow">
                        <div class="zxkc_content_right_ppt_item_text">
                            <div class="zxkc_content_right_ppt_item_text_left" style="display: -webkit-box;
-webkit-line-clamp: 1;
-webkit-box-orient: vertical;
overflow: hidden;
text-overflow: ellipsis;">
                                {{ item.title }}</div>
                            <div class="zxkc_content_right_ppt_item_text_right" @click="toDetail(item)">在线预览>></div>
                        </div>
                        <div class="zxkc_content_right_ppt_item_line">
                        </div>
                    </div>
                    <div class="el_pagination">
                        <el-pagination background layout="prev, pager, next" :page-size="9" :total="total"
                            @current-change="pageChange">
                        </el-pagination>
                    </div>
                </div>
                <div v-else
                    style="height: 100%; width: 100%;  display: flex; justify-content: center; color: #333333;">
                    <img style="height: 50%; width: 40%; object-fit: cover;"  src="../images/bgk.jpg"/>
                     
                </div>


            </div>
            <div class="zxkc_content_right_type2" v-if="type == '演示视频'">
                <div class="zxkc_content_right_ppt" v-if="listShow.length > 0">
                    <div class="zxkc_content_right_ppt_item" v-for="(item, index) in  listShow">
                        <div class="zxkc_content_right_ppt_item_text">
                            <div class="zxkc_content_right_ppt_item_text_left" style="display: -webkit-box;
-webkit-line-clamp: 1;
-webkit-box-orient: vertical;
overflow: hidden;
text-overflow: ellipsis;">
                                {{ item.title }}</div>
                            <div class="zxkc_content_right_ppt_item_text_right" @click="toDetail(item)">在线预览>></div>
                        </div>
                        <div class="zxkc_content_right_ppt_item_line">
                        </div>
                    </div>
                    <div class="el_pagination">
                        <el-pagination background layout="prev, pager, next" :page-size="9" :total="total"
                            @current-change="pageChange">
                        </el-pagination>
                    </div>
                </div>
                <div v-else
                    style="height: 100%; width: 100%;  display: flex; justify-content: center; color: #333333;">
                    <img style="height: 50%; width: 40%; object-fit: cover;"  src="../images/bgk.jpg"/>
                     
                </div>

            </div>
        </div>

    </div>
</template>
<script>
import { url } from '../services/url'
import {
    getCourseList
} from "../services/services";
export default {
    name: 'Index',
    data() {
        return {
            type: '教学视频',

            total: 1,
            pageSize: 9,
            pageNum: 1,
            listShow: [],
            userId: localStorage.getItem('userId'),
            haslogin: false,
            getUrl: url
        }
    },
    created() {
        const loading = this.$loading({
            lock: true,
            text: 'Loading',
            spinner: 'el-icon-loading',
            background: 'rgba(0, 0, 0, 0.7)'
        });
        getCourseList(this.userId, this.type, this.pageNum, this.pageSize).then(res => {
            this.total = res.total
            this.listShow = res.rows
            console.log(res)
            loading.close()
        })
        if (localStorage.getItem('haslogin') == 1) {
            this.haslogin = true
            this.studentName = localStorage.getItem('studentName')
        }
        if (this.$route.query.item != undefined) {
            if (this.$route.query.item.id != undefined) {
                this.toDetail(this.$route.query.item)
            }
        }
    },
    methods: {
        viewPpt() {
            this.$router.push({
                path: '/ViewPpt',
            });
        },
        changeType(type) {
            this.pageNum = 1
            this.type = type
            getCourseList(this.userId, this.type, this.pageNum, this.pageSize).then(res => {
                this.total = res.total
                this.listShow = res.rows
                console.log(res)
                loading.close()

            }).catch(err => {
                loading.close()

            })

        },
        pageChange(e) {
            this.pageNum = e
            getCourseList(this.userId, this.type, this.pageNum, this.pageSize).then(res => {
                this.total = res.total
                this.listShow = res.rows
            }).catch(err => {

            })
        },
        toDetail(item) {
            if (localStorage.getItem('haslogin') != 1 && item.isLoginView == '是') {
                this.$message({
                    message: '当前课程需登录后才可查看，请点击右上角进行登录',
                    type: 'warning'
                });
                return
            }
            if ((item.sourceUrl == null || item.sourceUrl == '') && (item.outUrl == null || item.outUrl == '')) {
                this.$message({
                    message: '当前课程没有资源',
                    type: 'warning'
                });
                return

            }
            else if (item.outUrl != null && item.outUrl != '') {
                window.open(item.outUrl, "_blank")
            }
            else {
                if (this.type == '教学视频' || this.type == '演示视频') {
                    this.$router.push({
                        path: '/ViewMp4',
                        query: {
                            url: this.getUrl + item.sourceUrl
                        }
                    });
                }
                else {
                    this.$router.push({
                        path: '/ViewPpt',
                        query: {
                            url: this.getUrl + item.sourceUrl
                        }
                    });
                }


            }
        }
    },
}
</script>
<style>
/* 或者本地文件 */
@import url('../css/style.css');
</style>